import { useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

const getSystemInfo = async () => {
  const response: { sci_version_latest: string } = await API.get(
    'publicapi',
    `/public/system-info`,
    {},
    false,
    undefined,
    {
      tags: {
        section: SECTIONS.SYSTEM,
        domain: DOMAINS.SYSTEM,
        importance: IMPORTANCE.LOW,
      },
      context: {},
    },
  );
  return response ?? {};
};

export const useSystemInfo = () => {
  const { data: systemInfo } = useQuery({
    queryKey: ['systemInfo'],
    queryFn: () => {
      const response = getSystemInfo();
      return response;
    },
  });
  return {
    latestSciVersion: systemInfo?.sci_version_latest,
  };
};
